import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import AppRouter from "./routes";
import { ThemeProvider, createTheme } from "@mui/material";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./css/master.css";
import { ContextProvider } from "./context/ContextProvider/ContextProvider";
import { instance } from "./api";
import { setupAxiosInterceptors } from "./api/setupInterceptors";
import "leaflet/dist/leaflet.css";

setupAxiosInterceptors(instance);

const theme = createTheme({
  palette: {
    primary: {
      main: "#10418a",
    },
    secondary: {
      main: "#ff8000",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ContextProvider>
          <AppRouter />
        </ContextProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
